import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesTarget, SalesTargetCreate, SalesTargetFilter } from '../data/salesTarget';

export function createSalesTargetService(client: AxiosInstance) {
  return createCrudService<SalesTarget, SalesTargetCreate, SalesTargetFilter>(
    client,
    '/sales/SalesTarget',
    'id',
  );
}

export type SalesTargetService = CrudService<SalesTarget, SalesTargetCreate, SalesTargetFilter>;
